export default {
    routerName: '部门详情',
    dept: {
        name: '部门名',
        parentName: '父级部门',
        leader: '负责人',
        mobile: '手机号',
        email: '邮箱',
        status: '状态',
        open: '启用',
        close: '停用',
        sortOrder: '排序',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
    },
};
